import { CartPopup } from "./CartPopup";
import { useCart } from "../context/cartContext";
import { useToast } from "../hooks/use-toast";
import { CheckCircle } from "lucide-react";
import { useEffect, useState } from "react";

export function CartPopupWrapper() {
  const { showCartPopup, setShowCartPopup } = useCart();
  const { toast } = useToast();
  const [isDesktop, setIsDesktop] = useState<boolean | null>(null);

  useEffect(() => {
    // Tailwind lg breakpoint: 1024px+
    const mql = window.matchMedia("(min-width: 1024px)");
    const onChange = () => setIsDesktop(mql.matches);

    onChange();
    mql.addEventListener("change", onChange);
    return () => mql.removeEventListener("change", onChange);
  }, []);

  useEffect(() => {
    if (isDesktop !== false || !showCartPopup) return;

    toast({
      title: "Added to cart",
      description: "Item added to your cart",
      action: <CheckCircle className="h-4 w-4 text-green-500" />,
       className: "w-[280px] min-h-0 px-3 py-2 text-xs gap-1 rounded-md",
    });
    setShowCartPopup(false);
  }, [showCartPopup, isDesktop, toast, setShowCartPopup]);

  if (!isDesktop) return null;

  return (
    <CartPopup
      isVisible={showCartPopup}
      onClose={() => setShowCartPopup(false)}
    />
  );
}

